import { useEffect, useState } from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import Sidebar from "./Sidebar";
import Topbar from "./Topbar";
import WelcomeOverlay from "./WelcomeOverlay";

export default function Layout() {
  const { user, loading } = useAuth();
  const location = useLocation();
  const [welcome, setWelcome] = useState(!!location.state?.welcome);

  useEffect(() => {
    if (welcome) {
      const t = setTimeout(() => setWelcome(false), 1800);
      return () => clearTimeout(t);
    }
  }, [welcome]);

  if (loading) {
    return (
      <div className="flex h-screen items-center justify-center bg-[#F8FAFC]">
        <div className="h-10 w-10 animate-spin rounded-full border-4 border-[#0891B2] border-t-transparent" />
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  return (
    <div className="min-h-screen bg-[#F8FAFC]">
      {welcome && <WelcomeOverlay name={user.name} />}
      <Sidebar />
      <div className="md:pl-64">
        <Topbar />
        <main className="p-4 md:p-6 lg:p-8">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
